module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-8-85b2298a15475e5e8c060003d9fa2925.jpg";